export const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;

export type UtmKey = typeof UTM_KEYS[number];

export type UtmParams = Partial<Record<UtmKey, string>>;

const UTM_STORAGE_KEY = 'utms';

// Guarda los utm que traiga la url para poder mandarlos despues al comprar.
// Si la url no trae utm no se pisa lo guardado: asi sobreviven a la navegacion
// interna del SPA, igual que el referrer.
export const saveUtmParamsFromUrl = (search: string = window.location.search) => {
    const params = new URLSearchParams(search);
    const utms: UtmParams = {};

    UTM_KEYS.forEach((key) => {
        const value = params.get(key);
        if (value) {
            utms[key] = value;
        }
    });

    if (Object.keys(utms).length > 0) {
        localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utms));
    }
}

export const getUtmParams = (): UtmParams | null => {
    const stored = localStorage.getItem(UTM_STORAGE_KEY);
    if (!stored) {
        return null;
    }

    try {
        const utms = JSON.parse(stored);
        return utms && Object.keys(utms).length > 0 ? utms : null;
    } catch (error) {
        console.log(error);
        return null;
    }
}

export const removeUtmParams = () => {
    localStorage.removeItem(UTM_STORAGE_KEY);
}
